import React from "react";
import { InfiniteHits } from "react-instantsearch/dom";
import InfiniteCard from "./InfiniteCard";

export default function LoadedResults() {
	/*
    // instantsearch.widgets.infiniteHits({
    //     container: "#infinite-hits-container",
    //     // showPrevious: false,
    //     templates: {
    //         item: document.getElementById("infinite-hits-container").innerHTML,
    //         empty: 'We didn \'t find any results for the search <em>"{{query}}"</em>',
    //         showMoreText: "Load More ",
    //     },
    // }),
    */

	return (
		<div className="results-container">
			<div id="infinite-hits-container " className="ais-InfiniteHits w-embed ">
				<InfiniteHits hitComponent={InfiniteCard} />
			</div>
		</div>
	);
}
